import jsPDF from "jspdf";

export function handleExportClickDriver(
  transactions,
  columns,
  selectedColumns,
  title,
  fileName
) {
  const doc = new jsPDF();
  const imgWidth = 100;
  const imgHeight = 100;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const x = (pageWidth - imgWidth) / 2;
  const y = (pageHeight - imgHeight) / 2;

  doc.addImage("/eTaxi2.png", "PNG", x, y, imgWidth, imgHeight);

  const textX = x + imgWidth / 2;
  const textY = y - 10;

  doc.setFontSize(18);
  doc.text(`eTaxi ${title} list`, textX, textY, {
    align: "center",
  });

  doc.setFontSize(12);

  doc.addPage();

  doc.setFontSize(14);
  const tableData = transactions.map((transaction) =>
    columns.map((column) => {
      if (selectedColumns.includes(column.Header)) {
        const accessorKeys = column.accessor;
        let data = transaction;

        if (data[accessorKeys] !== undefined) {
          data = data[accessorKeys];
        }

        return data;
      }
    })
  );

  const tableWidth = "auto"; // Set the desired table width ('auto' or a specific number)
  const margin = { top: 15, right: 15, bottom: 15, left: 15 }; // Adjust margins as needed

  doc.autoTable({
    head: [
      columns.map((column) => {
        if (selectedColumns.includes(column.Header)) {
          return column.Header;
        }
      }),
    ],
    body: tableData,
    tableWidth,
    // margin,
  });

  // doc.autoTable({
  //   head: [columns.map((column) => column.Header)],
  //   body: tableData,
  // });

  doc.save(fileName);
}
